import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { Text } from 'web-makeup/dist/design-system/styles/typography'

const XXS_BREAKING_POINT = '@media (max-width: 580px)'

export const Wrapper = styled.div<{ isCurrentUser: boolean }>`
  background: white;
  padding: 0.75rem 0 0.625rem;
  border-radius: 0.75rem;
  border: ${({ isCurrentUser }) =>
    isCurrentUser ? `2px solid ${colors.adaptBlue}` : `1px solid ${colors.gandalf}`};
  width: 100%;

  @media (max-width: 36.25rem) {
    margin-bottom: 1.5rem;
  }
`

export const ImageHolder = styled.div<{ image: string }>`
  height: 3.125rem;
  width: 3.125rem;
  border-radius: 50%;
  background: url(${({ image }) => `${image}`}) no-repeat center;
  background-size: cover;
  margin: 0.625rem auto 0;
`

export const StyledText = styled(Text as any)`
  margin-bottom: 0;
`
export const TagBar = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.875rem;
  display: flex;
  justify-content: space-between;
`

export const Tag = styled.div<{ isOnline?: boolean }>`
  color: white;
  background-color: ${({ isOnline }) => (isOnline ? '#36C17E' : colors.saruman)};
  font-size: 0.75rem;
  line-height: 1rem;
  border-radius: 4.375rem;
  text-align: center;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  padding: 0 0.688rem;
`

export const ActionIconsCnt = styled.div`
  display: flex;
  justify-content: space-around;
  padding-top: 1rem;
  margin-bottom: 1.188rem;

  > div {
    display: flex;
    align-items: center;
  }

  ${XXS_BREAKING_POINT} {
    flex-direction: column;
  }
`

export const ActionIconsWrapper = styled.div`
  > div {
    border-right: 1px solid ${colors.gandalf};
  }

  > div:last-child {
    border-right: none;
  }
`

export const ActionIcon = styled.a`
  ${XXS_BREAKING_POINT} {
    display: block;
    text-align: center;
  }
`

export const Divider = styled.div`
  height: 0;
  width: 100%;
  border-bottom: 1px solid ${colors.gandalf};
  margin-bottom: 0.625rem;
`
export const IconWrapper = styled.span`
  cursor: pointer;
  margin-left: 0.625rem;

  &:hover {
    path {
      transition: all 0.3s ease;
      fill: ${colors.black1};
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/TeamCard/card.style.tsx